module.exports = __webpack_public_path__ + "378190cee34340e512bec161ad49a4ce.woff";


//////////////////
// WEBPACK FOOTER
// ../apps/chide/products/smapply/static/themes/fonts/National2Web-Regular.woff
// module id = 2513
// module chunks = 17